<template>
  <div>

      <h1>My Reservations</h1>

      <div class="alert" v-if="msg">
        {{msg}}
      </div>

      <div class="reservations">
        <div v-for="(reservation, index) in reservations" :key="'reservation_'+reservation.id" class="reservation">
          <div class="card-header">Reservation #{{index}}</div>
          <div class="card-body">
            <div class="field">
              <div class="label">Date</div>
              <div class="value">
                {{ moment(reservation.date).format("YYYY-MM-DD")}}
              </div>
            </div>
            <div class="field">
              <div class="label">Hour</div>
              <div class="value">
                {{reservation.start_hour}} - {{reservation.end_hour}}
              </div>
            </div>
            <div class="field">
              <div class="label">Status</div>
              <div class="value">
                {{reservation.status}}
              </div>
            </div>
            
          </div>
          <div class="card-actions">
            <button v-if="reservation.status=='new'" @click="cancel(reservation.id)">Cancel</button>
          </div>
        </div>
        <div v-if="reservations.length == 0">
          <h2>No reservations</h2>
        </div>
      </div>

  </div>
</template>

<script>
import moment from 'moment'
import { mapActions } from 'vuex'
export default {
  data: () => ({
    reservations:[],
    msg:null
  }),
  mounted(){
    this.myReservations()
    .then(({reservations}) => {
      this.reservations = reservations;
    })
  },
  methods:{
    ...mapActions("scheduler",["myReservations", "cancelReservation"]),
    cancel(reservationId){
      this.cancelReservation(reservationId)
      .then((data) => {
        this.msg = data.message
        this.reservations = data.reservations
      })
    },
    moment
  }
}
</script>

<style lang="less">
  .reservations{
    display: grid;
    width: 50%;
    margin: auto;
    gap: 20px;
    margin-bottom: 50px;
    .reservation{
      border:1px solid #000000;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      strong{
        font-weight: bold;
      }
      button{
        background-color: transparent;
        appearance: none;
      }
      .card{
        &-header{
          background-color: black;
          padding: 10px;
          color:white;
        }
        &-body{
          padding: 10px;
          .field {
            display: flex;
            margin-bottom: 6px;
            .label {
              margin-right: 30px;
            }
            .value {
              font-weight: 500;
            }
          }
        }
        &-actions{
          padding: 10px;
          display: flex;
          justify-content: flex-end;
          button {
            background-color: #c9af6b;
            padding: 10px 20px;
            border: 1px solid black;
          }
        }
      }
    }
  }
  
</style>